<template>
  <vue-apex-charts
    :type="template"
    :height="height"
    :options="options"
    :series="[{
        data:verticalAxisSeries}]"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "candle-chart",
  components: {
    VueApexCharts,
  },
  props: {
    template: String,
    horizontalAxis: Array,
    verticalAxisSeries: Array,
    height:String,
  },
  data() {
    return {
      options: {
        xaxis: {
          type: 'datetime',
        },
        chart: {
          id: 'vuechart-example'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
